import instanceAuth from "@network/auth";
import { PaginateTicket } from "@type/index";

export interface TicketCountResponse {
  totalTickets: number;
  availableTickets: number;
  usedTickets: number;
  expiredTickets: number;
}

export interface TicketCountParams {
  screen: 'MY_TICKET_LIST' | 'ADD_LUCKY_NUMBER';
  userId?: number;
  raffleId?: number;
}

export async function getTicketCounts(params?: TicketCountParams): Promise<TicketCountResponse> {
  const instance = instanceAuth();
  const res = await instance.get("/tickets/count", { 
    params: {
      screen: 'MY_TICKET_LIST',
      ...params
    }
  });
  return res.data.data; // Extract data from the nested response structure
}

export async function getTickets(data: PaginateTicket) {
  const instance = instanceAuth();
  const res = await instance.get("/tickets", { params: data });
  return res.data;
}

export async function createTicket(payload: {
  raffleIds?: number[];
  type?: string;
}) {
  const instance = instanceAuth();
  const res = await instance.post("/tickets", payload);
  return res.data;
}
